/* eslint-disable camelcase */
export const getProvinceLabel = orderData => {
  const { province_VUL, isThisVulcanOrder } = orderData;

  if (!province_VUL) return null; // fallback if province missing

  switch (province_VUL) {
    case 'Ontario':
      return isThisVulcanOrder ? 'Ontario (NON-ILEC)' : 'Ontario (ILEC)';

    case 'Québec':
      return isThisVulcanOrder ? 'Quebec (NON-ILEC)' : 'Quebec (ILEC)';

    default:
      return province_VUL; // just return province if no special case
  }
};
